import { ContactHero } from '@/components/sections/contact-page'
import { Contact } from '@/components/sections'
import { usePageTitle } from '@/hooks'

export const ContactPage = () => {
  usePageTitle('Contact Us')

  return (
    <>
      <ContactHero />
      <Contact />
    </>
  )
}
